import { combineReducers } from 'redux';
import Cookies from 'js-cookie';
import {
    EMPTY_CATEGORY,
    EMPTY_VEHICLE,
    GET_CATEGORY,
    GET_VEHICLE,
    RESET_VEHICLE,
    TOGGLE_BOX_LOADING,
    ADD_BOX_ERROR,
    REDIRECT
} from './actions'

const emptyVehicleState = {
    licencePlate : null,
    brand : {
        id : null,
        name : null,
        slug : null
    },
    modelGroup : {
        id : null,
        name : null,
        slug : null
    },
    model : {
        id : null,
        name : null,
        slug : null
    },
    type : {
        id : null,
        name : null,
        slug : null
    }
};

let defaultVehicleState = emptyVehicleState;

if (typeof SELECTED_VEHICLE != 'undefined' && SELECTED_VEHICLE !== null) {
    if(typeof SELECTED_VEHICLE.licencePlate=="undefined"){
        var cookie=Cookies.get('selected_vehicle');
        if(cookie){
            SELECTED_VEHICLE.licencePlate=JSON.parse(cookie).licencePlate;
        }
    }
    defaultVehicleState = SELECTED_VEHICLE;
}

function VehicleReducer(state = defaultVehicleState, action)
{
    switch (action.type) {
        case GET_VEHICLE :
            return action.payload;
        case RESET_VEHICLE :
            return defaultVehicleState;
        case EMPTY_VEHICLE :
            return emptyVehicleState;
        default:
            return state;
    }
}

let emptyCategoryState = {
    id: null,
    name: null,
    slug: null
};

let defaultCategoryState = emptyCategoryState;

if (typeof SELECTED_CATEGORY != 'undefined' && SELECTED_CATEGORY !== null) {
    defaultCategoryState = SELECTED_CATEGORY;
}

function CategoryReducer(state = defaultCategoryState, action)
{
    switch (action.type) {
        case GET_CATEGORY :
            return action.payload;
        case EMPTY_CATEGORY :
            return emptyCategoryState;
        default :
            return state;
    }
}

const defaultStatuses = {
    loading : false,
    error : false,
    selected : false
};

const defaultBoxStatuses = {
    licencePlate : {...defaultStatuses},
    vehicleSelection : {...defaultStatuses},
    partName : {...defaultStatuses},
    partReference : {...defaultStatuses}
};

function BoxStatusesReducer(state = defaultBoxStatuses, action)
{
    let newState;
    let boxName;
    switch (action.type) {
        case TOGGLE_BOX_LOADING :
            boxName = action.payload.boxName;
            newState = {...state};
            newState[boxName].loading = !state[boxName].loading;
            return newState;
        case ADD_BOX_ERROR :
            boxName = action.payload.boxName;
            newState = {...state};
            newState[boxName].error = action.payload.errorMessage;
            return newState;
        case GET_CATEGORY :
            newState = {...state};
            if (null !== action.payload) {
                newState.partName.selected = true;
                newState.partReference.selected = true;
            }
            return newState;
        case EMPTY_CATEGORY :
            newState = {...state};
            newState.partName.selected = false;
            newState.partReference.selected = false;
            return newState;
        case GET_VEHICLE :
            newState = {...state};
            if (null !== action.payload) {
                newState.licencePlate.selected = true;
                newState.vehicleSelection.selected = true;
            }
            return newState;
        case EMPTY_VEHICLE :
            newState = {...state};
            newState.licencePlate.selected = false;
            newState.vehicleSelection.selected = false;
            return newState;
        default:
            return state;
    }
}

function RedirectReducer(state = null, action)
{
    switch (action.type) {
        case REDIRECT :
            window.location = action.payload.url;
            return action.payload.url;
        default :
            return state;
    }
}

const rootReducer = combineReducers({
    vehicle : VehicleReducer,
    category : CategoryReducer,
    boxStatuses : BoxStatusesReducer,
    redirectReducer : RedirectReducer
});

export default rootReducer;